import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import moment from "moment";
import * as XLSX from "xlsx";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

import { v4 as uuidv4 } from "uuid";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function OrdenesCompraCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_ORDENES_COMPRA = process.env.REACT_APP_URL_ORDENES_COMPRA;
  const URL_ARTICULOS_OC = process.env.REACT_APP_URL_ARTICULOS_OC;
  const URL_VARIANTES = process.env.REACT_APP_URL_VARIANTES_ARTICULOS;
  const URL_NOTAS_CXP = process.env.REACT_APP_URL_NOTAS_CXP;
  const URL_DESTINOS = process.env.REACT_APP_URL_DESTINOS_COMPRA;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [destinos, setDestinos] = useState([]);
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [selectedDestino, setSelectedDestino] = useState("");
  const [moneda, setMoneda] = useState("");

  const [fecha, setFecha] = useState(hoy);
  const [plazo, setPlazo] = useState(0);
  const [fecha_compromiso, setFechaCompromiso] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [tipoCambio, setTipoCambio] = useState(0);
  const [noFactura, setNoFactura] = useState("");
  const [total_general, setTotalGeneral] = useState(0);
  const [total_cantidad, setTotalCantidad] = useState(0);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [totalCaptura, setTotalCaptura] = useState(1);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      articulosNombre: "",
      cantidad: 0,
      precio: 0,
      total: 0,
      gastosEnvio: 0,
      gastosImportacion: 0,
      variante: "",
      variantesOptions: [],
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    const auth = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };
    axios.get(URL_ARTICULOS, auth)
      .then((res) => setArticulos(res.data))
      .catch((err) => console.log(err));
    axios.get(URL_PROVEEDORES, auth)
      .then((res) => setProveedores(res.data))
      .catch((err) => console.log(err));
    axios.get(URL_DESTINOS, auth)
      .then((res) => setDestinos(res.data))
      .catch((err) => console.log(err));
  }, []);

  const saveOrdenCompra = async (event) => {
    event.preventDefault();
    setValidaBoton(false);
    toggleProgreso();

    let totalArticulos = inputFields.length;

    try {
      await axios
        .post(
          URL_ORDENES_COMPRA,
          {
            fecha,
            proveedores: selectedProveedor,
            plazo,
            fecha_compromiso,
            total_general,
            total_cantidad,
            observaciones,
            embarcado: 0,
            moneda,
            tipoCambio: parseFloat(tipoCambio) || 0,
            noFactura,
            destino: selectedDestino || null,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        )
        .then((data) => {
          const ocId = data.data._id;
          const tc = parseFloat(tipoCambio) || 1;
          const totalMXN = moneda === "USD" ? total_general * tc : total_general;
          const auth = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };

          // Auto-crear CxP al guardar OC
          axios.post(URL_NOTAS_CXP, {
            proveedores: selectedProveedor,
            ordenesCompra: ocId,
            total_cantidad,
            total_costo: parseFloat(totalMXN).toFixed(2),
            saldo: parseFloat(totalMXN).toFixed(2),
            fecha,
          }, auth).catch((err) => console.log("CxP error:", err));

          inputFields.map((a) => {
            axios
              .post(
                URL_ARTICULOS_OC,
                {
                  ordenesCompra: ocId,
                  articulos: a.articulos,
                  cantidad: parseFloat(a.cantidad),
                  embarcado: 0,
                  pendiente_embarcar: parseFloat(a.cantidad),
                  precio: parseFloat(a.precio),
                  total: parseFloat(a.total),
                  gastosEnvio: parseFloat(a.gastosEnvio) || 0,
                  gastosImportacion: parseFloat(a.gastosImportacion) || 0,
                  variante: a.variante || null,
                },
                auth
              )
              .then(() => {
                totalArticulos = totalArticulos - 1;
                if (totalArticulos == 0) {
                  axios
                    .post(
                      URL_LOGS,
                      {
                        tipo: "Crear Orden de Compra",
                        detalle: `${selectedProveedor} ${total_general}`,
                        user: user.id,
                      },
                      auth
                    )
                    .then(() => {
                      Swal.fire("Good job!", "Creado con exito", "success");
                      setTimeout(() => {
                        window.location.reload();
                      }, 1000);
                    })
                    .catch((error) => {
                      Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: "Something went wrong!",
                        footer: `${error.response.data}`,
                      });
                      console.log(error);
                      setValidaBoton(true);
                    });
                }
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                });
                console.log(error);
                setValidaBoton(true);
              });
          });
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
          console.log(error);
          setValidaBoton(true);
        });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
      console.log(error);
    }
  };
  const handleAddFields = () => {
    const ultimo = inputFields[inputFields.length - 1];
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        articulos: ultimo.articulos,
        articulosNombre: ultimo.articulosNombre,
        cantidad: 0,
        precio: ultimo.precio,
        total: 0,
        gastosEnvio: 0,
        gastosImportacion: 0,
        variante: "",
        variantesOptions: ultimo.variantesOptions || [],
      },
    ]);
  };

  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);
    let cant = values.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);
    let importes = values.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneral(TG);
  };

  const handleChangeInput = (id, event) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i[event.target.name] = event.target.value;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function BuscaArticulo(id, selectedArticulo) {
    if (!selectedArticulo) return;
    const auth = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };
    const idArticulo = selectedArticulo._id;
    const FOB = selectedArticulo.costoUSD || 0;
    const artNombre = (selectedArticulo.MLM || selectedArticulo.SKU || "") + " " + (selectedArticulo.nombre || "");
    axios.get(`${URL_VARIANTES}/articulo/${idArticulo}`, auth)
      .then(res => handleChangeInputArticulo(id, idArticulo, FOB, artNombre.trim(), res.data))
      .catch(() => handleChangeInputArticulo(id, idArticulo, FOB, artNombre.trim(), []));
  }

  const handleChangeInputArticulo = (id, idArticulo, FOB, articulosNombre, variantesOptions = []) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        i.articulosNombre = articulosNombre;
        i.total = 0;
        i.precio = FOB;
        i.cantidad = 0;
        i.gastosEnvio = 0;
        i.gastosImportacion = 0;
        i.variante = "";
        i.variantesOptions = variantesOptions;
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };

  function ActualizaTotales() {
    let cant = inputFields.map((c) => parseFloat(c.cantidad));
    let TC = cant.reduce((t, total, index) => t + total, 0);
    setTotalCantidad(TC);
    let importes = inputFields.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneral(TG);
  }

  function jalaProveedor(e) {
    setInputFields([
      {
        id: uuidv4(),
        articulos: "",
        articulosNombre: "",
        cantidad: 0,
        precio: 0,
        total: 0,
        gastosEnvio: 0,
        gastosImportacion: 0,
        variante: "",
        variantesOptions: [],
      },
    ]);
    setSelectedProveedor(e);
    proveedores.map((a) => {
      if (a._id == e) {
        return setMoneda(a.moneda);
      }
    });
  }

  const options = articulos.map((option) => {
    const mlm = option.MLM || option.SKU || "";
    const junta = mlm + " " + (option.nombre || "");
    const firstLetter = mlm[0] ? mlm[0].toUpperCase() : "?";
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

//     function importarArchivo(event){
//    const target = event.target;
//    const value = target.type === "checkbox" ? target.checked : target.value;
//    const name = target.name;
//    let hojas = [];
  
//    if (name === "file") {
 
//      let reader = new FileReader();
//        reader.readAsArrayBuffer(target.files[0]);
//        reader.onloadend = (e) => {
//          var data = new Uint8Array(e.target.result);
//          var workbook = XLSX.read(data, { type: "array" });
 
//          workbook.SheetNames.forEach(function (sheetName) {
//            // Here is your object
//            var XL_row_object = XLSX.utils.sheet_to_json(
//              workbook.Sheets[sheetName]
//            );
//            hojas.push({
//              data: XL_row_object,
//              sheetName,
//            });
//          });
 
//          let A1 = hojas[0].data
 
//          let TC = totalCaptura
//          A1.map((a)=>{
//             TC = TC + 1
//            setTotalCaptura(TC)
//          inputFields.push({
//            id: uuidv4(),
//            articulos: a.articulos,
//           cantidad: a.cantidad,
//           precio: 0,
//           total: 0,
//           articulosNombre: a.articulosNombre
//          })
//          })
 
//          ActualizaTotales()
//        }
//    }
//  }
//  console.log("hola", inputFields)

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_oc ? (
        <div className="card container col-12">
          <h3 align="center">Nueva Orden de Compra</h3>
          <Form onSubmit={saveOrdenCompra}>

            {/* 📋 Encabezado */}
            <div style={{ background: "#f8fafc", borderRadius: 8, padding: "14px 16px", marginBottom: 16 }}>
              <div style={{ borderLeft: "4px solid #3b82f6", paddingLeft: 12, marginBottom: 12, color: "#1e3a8a", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>📋 Encabezado</div>
              <Row>
                <Col md={2}>
                  <Label>Fecha</Label>
                  <Input type="date" value={fecha} required onChange={(e) => setFecha(e.target.value)} />
                </Col>
                <Col md={3}>
                  <Label>Proveedor</Label>
                  <Input className="col-sm-12" type="select" value={selectedProveedor} required onChange={(e) => jalaProveedor(e.target.value)}>
                    <option value="0">Selecciona un Proveedor</option>
                    {proveedores.sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1)).map((a) => (
                      <option key={a._id} value={a._id}>{a.nombre_comercial} — {a.moneda}</option>
                    ))}
                  </Input>
                </Col>
                <Col md={2}>
                  <Label>Plazo (días)</Label>
                  <Input type="text" placeholder="Ej. 30" value={plazo} required onChange={(e) => setPlazo(e.target.value)} />
                </Col>
                <Col md={2}>
                  <Label>Fecha Compromiso</Label>
                  <Input type="date" value={fecha_compromiso} required onChange={(e) => setFechaCompromiso(e.target.value)} />
                </Col>
                <Col md={1}>
                  <Label>T.C. (USD→MXN)</Label>
                  <Input type="number" min="0" step="any" placeholder="0" value={tipoCambio} onChange={(e) => setTipoCambio(e.target.value)} />
                </Col>
                <Col md={2}>
                  <Label>No. Factura</Label>
                  <Input type="text" placeholder="No. Factura" value={noFactura} onChange={(e) => setNoFactura(e.target.value)} />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col md={3}>
                  <Label>Destino</Label>
                  <Input type="select" value={selectedDestino} onChange={(e) => setSelectedDestino(e.target.value)}>
                    <option value="">Sin destino</option>
                    {destinos.map((d) => (
                      <option key={d._id} value={d._id}>{d.nombre}</option>
                    ))}
                  </Input>
                </Col>
              </Row>
            </div>

            {/* 📦 Artículos */}
            <div style={{ background: "#f8fafc", borderRadius: 8, padding: "14px 16px", marginBottom: 16 }}>
              <div style={{ borderLeft: "4px solid #3b82f6", paddingLeft: 12, marginBottom: 12, color: "#1e3a8a", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span>📦 Artículos</span>
                <span style={{ background: "#dbeafe", color: "#1e3a8a", borderRadius: 20, padding: "2px 12px", fontSize: "0.8rem", fontWeight: 700 }}>
                  {total_cantidad} pzas — ${new Intl.NumberFormat("en-US").format(total_general)} {moneda}
                </span>
              </div>
              <div className="table-responsive">
                <table className="table table-sm table-bordered" style={{ marginBottom: 0 }}>
                  <thead className="thead-light">
                    <tr>
                      <th style={{ minWidth: 260 }}>Artículo</th>
                      <th style={{ minWidth: 140 }}>Variante</th>
                      <th style={{ width: 90 }}>Cantidad</th>
                      <th style={{ width: 110 }}>Precio {moneda === "USD" ? "USD" : moneda || "MXN"}</th>
                      <th style={{ width: 120 }}>Total</th>
                      <th style={{ width: 105 }}>G. Envío</th>
                      <th style={{ width: 105 }}>G. Import.</th>
                      <th style={{ width: 80 }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {inputFields.map((inputField) => (
                      <tr key={inputField.id}>
                        <td>
                          <Autocomplete
                            size="small"
                            value={inputField.articulosNombre}
                            onChange={(event, selectedArticulo) => BuscaArticulo(inputField.id, selectedArticulo)}
                            options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                            groupBy={(option) => option.firstLetter}
                            getOptionLabel={(option) => typeof option === "string" ? option : option.junta}
                            renderInput={(params) => <TextField {...params} label="Selecciona" variant="outlined" />}
                            renderOption={(option) => (
                              <React.Fragment>{option.MLM || option.SKU} {option.nombre}</React.Fragment>
                            )}
                          />
                        </td>
                        <td className="align-middle">
                          {inputField.variantesOptions && inputField.variantesOptions.length > 0 ? (
                            <Input bsSize="sm" type="select" value={inputField.variante}
                              onChange={e => {
                                const upd = inputFields.map(i => i.id === inputField.id ? { ...i, variante: e.target.value } : i);
                                setInputFields(upd);
                              }}>
                              <option value="">Sin variante</option>
                              {inputField.variantesOptions.map(v => (
                                <option key={v._id} value={v._id}>{v.nombre}</option>
                              ))}
                            </Input>
                          ) : (
                            <span style={{ color: "#9ca3af", fontSize: "0.8rem" }}>—</span>
                          )}
                        </td>
                        <td>
                          <Input bsSize="sm" name="cantidad" type="number" min="0" step="any"
                            value={inputField.cantidad} required
                            onChange={(e) => handleChangeInput(inputField.id, e)} />
                        </td>
                        <td>
                          <Input bsSize="sm" name="precio" type="number" min="0" step="any"
                            value={inputField.precio} required
                            onChange={(e) => handleChangeInput(inputField.id, e)} />
                        </td>
                        <td className="align-middle">
                          <strong>{new Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(inputField.total)}</strong>
                        </td>
                        <td>
                          <Input bsSize="sm" name="gastosEnvio" type="number" min="0" step="any"
                            value={inputField.gastosEnvio}
                            onChange={(e) => handleChangeInput(inputField.id, e)} />
                        </td>
                        <td>
                          <Input bsSize="sm" name="gastosImportacion" type="number" min="0" step="any"
                            value={inputField.gastosImportacion}
                            onChange={(e) => handleChangeInput(inputField.id, e)} />
                        </td>
                        <td className="text-center align-middle">
                          <Button size="sm" color="danger" disabled={inputFields.length === 1}
                            onClick={() => handleRemoveFields(inputField.id)} tabIndex="-1">
                            <i className="fas fa-minus" />
                          </Button>{" "}
                          <Button size="sm" color="info" onClick={handleAddFields} tabIndex="-1">
                            <i className="fas fa-plus" />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* 📝 Observaciones */}
            <Row className="mb-3">
              <Col md={8}>
                <Label>Observaciones</Label>
                <Input type="textarea" rows={2} placeholder="Observaciones" value={observaciones} required
                  onChange={(e) => setObservaciones(e.target.value)} />
              </Col>
            </Row>

            {validaBoton ? (
              <Button type="submit" color="success"><i className="fas fa-save" style={{ marginRight: 6 }} />Guardar</Button>
            ) : (
              <Button type="submit" color="success" disabled><i className="fas fa-save" style={{ marginRight: 6 }} />Guardar</Button>
            )}
            {" "}
            <Button href="/ListadoOrdenesCompra" color="danger" id="botonListado">
              <i className="fas fa-arrow-left" style={{ marginRight: 6 }} />Regresar
            </Button>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default OrdenesCompraCreate;
